import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactSection from '../home/components/ContactSection';

export default function Contact() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative py-24 bg-gradient-to-br from-amber-50 to-orange-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
            <div className="text-center mb-12 sm:mb-16">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
                Get in <span className="text-amber-600">Touch</span>
              </h1>
              <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto px-4">
                Ready to start your construction project? Contact DDR CONSTRUCTION SOLUTIONS today for a free estimate
              </p>
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-3 gap-8 mb-16">
              <div className="text-center p-8 bg-gray-50 rounded-lg">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-phone-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Phone</h3>
                <a href="tel:502-533-0524" className="text-lg text-amber-600 hover:text-amber-700 cursor-pointer">
                  502-533-0524
                </a>
              </div>

              <div className="text-center p-8 bg-gray-50 rounded-lg">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Response Time</h3>
                <p className="text-lg text-gray-600">
                  Fast & Reliable
                </p>
              </div>

              <div className="text-center p-8 bg-gray-50 rounded-lg">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-instagram-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Instagram</h3>
                <a 
                  href="https://www.instagram.com/ddrconstructionsolutions/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-lg text-amber-600 hover:text-amber-700 cursor-pointer"
                >
                  @ddrconstructionsolutions
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <ContactSection />

        {/* Additional Info */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Any Job, Any Size
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              From small repairs to major renovations, we handle it all. Contact us today for a free estimate and let's discuss how we can bring your vision to life.
            </p>
            <div className="grid md:grid-cols-2 gap-6 text-left">
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-amber-600 mr-3 mt-1"></i>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Free Estimates</h3>
                  <p className="text-gray-600">No obligation quotes for all projects</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-amber-600 mr-3 mt-1"></i>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Fast Response</h3>
                  <p className="text-gray-600">Quick turnaround on estimates and scheduling</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-amber-600 mr-3 mt-1"></i>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Emergency Service</h3>
                  <p className="text-gray-600">Available for urgent repairs when you need us</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-amber-600 mr-3 mt-1"></i>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Quality Guaranteed</h3>
                  <p className="text-gray-600">Satisfaction guaranteed on every project</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
